import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import { useHistory } from "react-router-dom";

import "../../styles.css";

const AppCard = (props) => {
  let history = useHistory();
  const data = props.data;
  const bgColor = "white";
  return (
    <div>
      <div
        id="app_card"
        className="card  mb-3"
        style={{ width: "20rem", height: "13rem", boxShadow: "none" }}
      >
        <div
          className="card-header"
          id="app_cardHeader"
          style={{
            height: "4em",
            backgroundColor: `${bgColor}`,
            border: "none",
            fontFamily: "DM Sans",
          }}
        >
          <img
            className="rounded-circle"
            style={{ color: "#2C41C6" }}
            src={data.icon}
            width={
              data.name == "Microsoft Dynamics" ||
                data.name == "Zoho" ||
                data.name == "Vestorly" ||
                data.name == "Connect.Earth"
                ? "80"
                : "40"
            }
            height="40"
            alt=""
          />
        </div>
        <div
          className="card-body"
          style={{ backgroundColor: `${bgColor}`, opacity: "90%" }}
        >
          <h5
            className="card-title"
            id="app_cardTitle"
            style={{ fontSize: "14px", marginBottom: "0px", height: "30px" }}
          >
            {data.name}
          </h5>
          <p
            className="card-text"
            id="app_cardText"
            style={{ fontSize: "12px" }}
          >
            {data.description}
          </p>
        </div>
        <div
          className="card-footer"
          style={{ border: "none", backgroundColor: `${bgColor}` }}
        >
          <a
            href="#"
            onClick={(e) => {
              if (props.appInstallPermission) {
                e.preventDefault();
                localStorage.setItem("app_id", props.data.id);
                localStorage.setItem("app_isConfigured", data.isConfigured);
                history.push("/admin/settings/app_config");
              }

            }}
            className="btn btn-primary"
            style={props.appInstallPermission ? {
              backgroundColor: "#2C40CE",
              width: "40%",
              fontFamily: "DM Sans",
              borderColor: "none",
              border: "none",
            } : {
              backgroundColor: "#969FE8",
              width: "40%",
              fontFamily: "DM Sans",
              borderColor: "none",
              border: "none",
              cursor: 'not-allowed'
            }}
          >
            {data.isConfigured ? (
              <>
                {/* <i className="fas fa-check" style={{ marginRight: '1vh', color: 'white' }} height='20'></i> */}
                Installed
              </>
            ) : (
              <>
                {/* <i className="fas fa-plus" style={{ marginRight: '1vh', color: 'white' }} height='20'></i> */}
                Install
              </>
            )}
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppCard;
